import React from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import storePersist from '../../../../../../redux/storePersist';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';



export default function OnboardOrganizationInfoComponent ({handleFormChange, subscriptionDetails}: any) {
    console.log(subscriptionDetails?.OrganizationDetails,'orgabization subscriptionDetails')
    const libraryData = useSelector(selectListItems)
    const statesItems = storePersist?.get("states")?.current?.items;
  
    const employees: any = [
      { Description: 'Up to 10 Employees', Value: 10 },
      { Description: 'Up to 50 Employees', Value: 20 },
      { Description: 'Up to 100 Employees', Value: 30 },
      { Description: 'Up to 200 Employees', Value: 40 },
      { Description: 'Up to 500 Employees', Value: 50 },
      { Description: 'Up to 1000 Employees', Value: 60 },
      { Description: 'Up to 2000 Employees', Value: 70 },
      { Description: 'Up to 5000 Employees', Value: 80 },
      { Description: 'Up to 10000 Employees', Value: 90 },
      { Description: 'More than 10000 Employees', Value: 100 },
    ]
  
    const turnover: any = [
      { Description: 'Up to INR 40 Lakhs', Value: 10 },
      { Description: 'Up to INR 5 Crores', Value: 20 },
      { Description: 'Up to INR 50 Crores', Value: 30 },
      { Description: 'Up to INR 100 Crores', Value: 40 },
      { Description: 'Up to INR 200 Crores', Value: 50 },
      { Description: 'Up to INR 500 Crores', Value: 60 },
      { Description: 'More than INR 500 Crores', Value: 70 },
    ]
  
    const applicationstatus: any = [
      { Description: 'Application Available and APIfied', Value: 10 },
      { Description: 'Application Available but insufficiently APIfied', Value: 20 },
      { Description: 'Application Unavailable', Value: 30 },
    ]
    return (
      <>
        <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
  
  label="Organization Name"
  name="Organization Name"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'OrganizationDetails.OrganizationName',
      data: subscriptionDetails?.OrganizationDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.OrganizationDetails?.OrganizationName}
  />
  <InputContainer
  
  label="Legal Entity Name"
  name="Legal Entity Name"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'OrganizationDetails.LegalEntityName',
      data: subscriptionDetails?.OrganizationDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.OrganizationDetails?.LegalEntityName}
  />
  <InputContainer
  
  label="Website URL"
  name="Website URL"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'OrganizationDetails.WebsiteURL',
      data: subscriptionDetails?.OrganizationDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.OrganizationDetails?.WebsiteURL}
  />
  <InputContainer
  
  label="Year of Corporation"
  name="Year of Corporation"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'OrganizationDetails.YearOfIncorporation',
      data: subscriptionDetails?.OrganizationDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.OrganizationDetails?.YearOfIncorporation}
  />
  <InputContainer
  
  label="No of employees"
  labelField="Description"
      list={employees}
      onValueChange={(event: any) => {
        handleFormChange({
          value: event.target.value,
          field: 'OrganizationDetails.NumberOfEmployees',
          data: subscriptionDetails?.OrganizationDetails
        });
      }}
      optionName='Choose Employees Count'
      type="select"
      value={subscriptionDetails?.OrganizationDetails?.NumberOfEmployees}
      valueField="Description"
  />
  
  <InputContainer
  
  label="Turnover of Organization"
  labelField="Description"
      list={turnover}
      onValueChange={(event: any) => {
        handleFormChange({
          value: event.target.value,
          field: 'OrganizationDetails.TurnOverOfOrganization',
          data: subscriptionDetails?.OrganizationDetails
        });
      }}
      optionName='Choose Turn over of organization'
      type="select"
      value={subscriptionDetails?.OrganizationDetails?.TurnOverOfOrganization}
      valueField="Description"
  />
  
  <InputContainer
  
  label="Nature of Organization"
  labelField="Description"
      list={libraryData?.result?.NatureOfOrganization}
      onValueChange={(event: any) => {
        handleFormChange({
          value: event.target.value,
          field: 'OrganizationDetails.NatureOfOrganization',
          data: subscriptionDetails?.OrganizationDetails
        });
      }}
      optionName='Choose Nature of organization'
      type="select"
      value={subscriptionDetails?.OrganizationDetails?.NatureOfOrganization}
      valueField="Description"
  />
  
  <InputContainer
  
  label="Sector of Organization"
  labelField="Description"
      list={libraryData?.result?.SectorOfOrganization}
      onValueChange={(event: any) => {
        handleFormChange({
          value: event.target.value,
          field: 'OrganizationDetails.SectorOfOrganization',
          data: subscriptionDetails?.OrganizationDetails
        });
      }}
      optionName='Choose Sector of organization'
      type="select"
      value={subscriptionDetails?.OrganizationDetails?.SectorOfOrganization}
      valueField="Description"
  />
  <InputContainer
  
  label="Status of Product Application"
  labelField="Description"
      list={applicationstatus}
      onValueChange={(event: any) => {
        handleFormChange({
          value: event.target.value,
          field: 'OrganizationDetails.StatusOfProduct_Application',
          data: subscriptionDetails?.OrganizationDetails
        });
      }}
      optionName='Choose Application status'
      type="select"
      value={subscriptionDetails?.OrganizationDetails?.StatusOfProduct_Application}
      valueField="Description"
  />
  <InputContainer
  
  label="All states or cities"
  name="IsAllStates_Cities"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'OrganizationDetails.IsAllStates_Cities',
      data: subscriptionDetails?.OrganizationDetails
    });
  }}
  type="cheskbox"
  value={subscriptionDetails?.OrganizationDetails?.IsAllStates_Cities}
  />
  
  <InputContainer
       label="AreaOfOperations_States" 
       labelField="Name"
       list={statesItems}
       onValueChange={( newValue: any) => {
         const countryData: any = newValue.map((option: any) => option?.value || '')
         handleFormChange({
          value: countryData,
          field: 'OrganizationDetails.AreaOfOperations_States',
          data: subscriptionDetails?.OrganizationDetails
        });
       }}
       type="multiselect"
       valueField="Name"
       value={subscriptionDetails?.OrganizationDetails?.AreaOfOperations_States}
   />
  
  <InputContainer
       label="Area of operations (cities)" 
       labelField="Area of operations (cities)"
       list={statesItems}
       onValueChange={( newValue: any) => {
         const countryData: any = newValue.map((option: any) => option?.value || '')
         handleFormChange({
          value: countryData,
          field: 'OrganizationDetails.AreaOfOperations_Cities',
          data: subscriptionDetails?.OrganizationDetails
        });
       }}
       type="multiselect"
       valueField="Id"
       value={subscriptionDetails?.OrganizationDetails?.AreaOfOperations_Cities}
   />
  
  <InputContainer
       label="DomainOfProductOrServices" 
       labelField="Description"
       list={libraryData?.result?.DomainOfProductServices}
       onValueChange={( newValue: any) => {
         const countryData: any = newValue.map((option: any) => option?.value || '')
         handleFormChange({
          value: countryData,
          field: 'OrganizationDetails.DomainOfProductOrServices',
          data: subscriptionDetails?.OrganizationDetails
        });
       }}
       type="multiselect"
       valueField="Description"
       value={subscriptionDetails?.OrganizationDetails?.DomainOfProductOrServices}
   />
  
  
  
    </div>
    }
    expandedPanel="Organization Details"
    headerTitle="Organization Details"
  />


        </>
  )
}